// Crow's-foot and inheritance markers. Each marker's tip touches the entity card; with
// orient="auto-start-reverse" the same marker works at either end of an edge.
const common = {
  viewBox: '0 0 20 20',
  refX: 20,
  refY: 10,
  markerWidth: 20,
  markerHeight: 20,
  markerUnits: 'userSpaceOnUse' as const,
  orient: 'auto-start-reverse',
};

const stroke = { fill: 'none', stroke: 'context-stroke', strokeWidth: 1.4, strokeLinecap: 'round' as const };
const hollow = { fill: 'var(--canvas)', stroke: 'context-stroke', strokeWidth: 1.4 };

export type MarkerId = 'mv-one' | 'mv-zero-one' | 'mv-many' | 'mv-zero-many' | 'mv-inherit' | 'mv-arrow';

export function DiagramMarkers() {
  return (
    <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
      <defs>
        <marker id="mv-one" {...common}>
          <path d="M11 4v12M15 4v12M0 10h20" {...stroke} />
        </marker>
        <marker id="mv-zero-one" {...common}>
          <path d="M15 4v12M9 10h11" {...stroke} />
          <circle cx="5.5" cy="10" r="3.2" {...hollow} />
        </marker>
        <marker id="mv-many" {...common}>
          <path d="M8 4v12M8 10h12M8 10 20 3M8 10l12 7" {...stroke} />
        </marker>
        <marker id="mv-zero-many" {...common}>
          <path d="M9 10h11M9 10 20 3M9 10l11 7" {...stroke} />
          <circle cx="5" cy="10" r="3.2" {...hollow} />
        </marker>
        <marker id="mv-inherit" {...common} markerWidth={18} markerHeight={18}>
          <path d="M3 3.5 19 10 3 16.5Z" {...hollow} strokeLinejoin="round" />
        </marker>
        {/* Code map: a call or use points at what it calls. */}
        <marker id="mv-arrow" {...common} markerWidth={14} markerHeight={14}>
          <path d="M8 4.5 19 10 8 15.5" {...stroke} strokeWidth={1.6} strokeLinejoin="round" />
        </marker>
      </defs>
    </svg>
  );
}
